// Normalizes an email before any lookup, comparison or write.
//
// Invisible formatting characters ride along when an address is copied from
// Outlook / Teams / PDFs. They are not whitespace, so String#trim() keeps them,
// and they can never legitimately appear in an email address.
// Keep in sync with the other copy of this helper (backend/src/utils/email.ts ↔ frontend/src/shared/utils/email.ts).
const INVISIBLE_EMAIL_CHARS = /[\u00AD\u200B-\u200D\u2060\uFEFF]/g;

export function normalizeEmail(email: unknown): string {
	if (typeof email !== "string") return "";
	return email.replace(INVISIBLE_EMAIL_CHARS, "").trim().toLowerCase();
}
